export default "__VITE_ASSET__yWggvQ80__"